<template>
  <z-card
    size="large"
    class="lead-collector-success"
  >
    <img
      class="lead-collector-success__icon"
      :alt="$t('icon-alt')"
      src="https://kong.quero.com/pi05aa08ui_001.svg"
    >
    <z-title
      tag="div"
      size="medium"
      class="lead-collector-success__title"
    >
      {{ $t('success.title') }}
    </z-title>
  </z-card>
</template>

<script>
import messages from './i18n/lead-collector.json'

export default {
  name: 'LeadCollectorSuccess',
  i18n: {
    messages: {
      'pt-BR': messages,
    },
  },
}
</script>

<style lang="scss" scoped>
  .lead-collector-success {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: var(--unit-0400);
    padding: var(--unit-0600);
  }

  .lead-collector-success__title {
    text-align: center;
  }
</style>
